import axios from "axios";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
// THIS BREAKS THE AUTH. redirect_url is derived from window.location.origin
// at call time by the caller.

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const authApi = axios.create({
  baseURL: API,
  withCredentials: true, // send session cookies
});

export const loginWithGoogle = (returnPath = "/minha-conta") => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
  // THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + returnPath;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const exchangeSessionId = async (sessionId) => {
  const r = await authApi.post("/auth/session", { session_id: sessionId });
  return r.data;
};

export const fetchCurrentUser = async () => {
  try {
    const r = await authApi.get("/auth/me");
    return r.data;
  } catch (e) {
    if (e?.response?.status === 401) return null;
    throw e;
  }
};

export const logout = async () => {
  await authApi.post("/auth/logout");
};

export const adminLogin = async (email, password) => {
  const r = await authApi.post("/auth/admin/login", { email, password });
  return r.data;
};

export const fetchAdminMe = async () => {
  try {
    const r = await authApi.get("/auth/admin/me");
    return r.data;
  } catch (e) {
    if (e?.response?.status === 401) return null;
    throw e;
  }
};

export const adminLogout = async () => {
  await authApi.post("/auth/admin/logout");
};

export const fetchMyQuotes = async () => {
  const r = await authApi.get("/my/quotes");
  return r.data;
};

export const fetchAllQuotesAdmin = async () => {
  const r = await authApi.get("/admin/quotes");
  return r.data;
};

export const updateQuoteAdmin = async (id, payload) => {
  const r = await authApi.patch(`/admin/quotes/${id}`, payload);
  return r.data;
};
